import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'app/scripts/components/common/inputs/text-field';
import validators from 'app/scripts/utils/validators';

class BroadcastUrl extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      status: 'none',
      message: '',
      broadcastUrl: props.value
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    var oldUrl = this.props.value;
    var newUrl = nextProps.value;
    if (oldUrl !== newUrl) {
      this.setState({ broadcastUrl: newUrl, status: 'success' });
    } else if (nextProps.validate) {
      this.onUrlChange(this.state.broadcastUrl);
    }
  }
  onUrlChange(broadcastUrl) {
    var empty = !broadcastUrl || !broadcastUrl.trim().length;
    var valid = validators.url(broadcastUrl);
    var state = this.state;

    state.status = 'none';
    state.message = '';
    if (empty) {
      state.message = "You can't leave this empty.";
      state.status = 'error';
    } else if (!valid) {
      state.message = 'That is not a valid url.';
      state.status = 'error';
    } else {
      state.status = 'success';
      state.message = '';
    }

    state.broadcastUrl = broadcastUrl;
    this.setState(state);
  }

  getValue() {
    return this.state.broadcastUrl;
  }

  isValid() {
    return this.state.status === 'success';
  }

  render() {
    var broadcastUrl = this.state.broadcastUrl;
    var { disabled } = this.props;
    var validation = {
      status: this.state.status || 'none',
      message: this.state.message
    };

    if (broadcastUrl === null) {
      // hack\patch to prevent a bug - value of input can't be null
      broadcastUrl = '';
    }
    return (
      <TextField
        className="outside"
        onChange={this.onUrlChange.bind(this)}
        description="URL of content"
        placeholder="Paste the URL of the content you want to promote"
        showValidationTooltip
        validation={validation}
        value={broadcastUrl}
        disabled={disabled}
      />
    );
  }
}

BroadcastUrl.propTypes = {
  validate: PropTypes.bool,
  value: PropTypes.string,
  disabled: PropTypes.bool
};

BroadcastUrl.defaultProps = {
  value: null
};

BroadcastUrl.displayName = 'BroadcastUrl';

export default BroadcastUrl;
